import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class AddTodo extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            message: '',
            redirect: false,
            apiUrl: this.decryptconfigdata('apiUrl'),
            owners: [],
            title: '',
            description: '',
            visibility: 'public',
            priority: [],
            priority_name:'',
            status: [],
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            userName: has_local_data ? localdata.user_name : '',
            fields: {},
            errors: {},
            attachments: '',
            search: [],
            errorText: '',
            searchText: '',
            start_date: '',
            ETA: '',
        }
        this.insertTodo = this.insertTodo.bind(this);
        this.onChange = this.onChange.bind(this);
        this.startdateChange = this.startdateChange.bind(this);
        this.etadateChange = this.etadateChange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    handleUpdateInput = (searchText) => {
        console.log(searchText)
        this.setState({
            searchText: searchText,
        });
        this.GetTodosTitle(searchText);
    };
    handleNewRequest = (searchText) => {
        //console.log("hi" + this.state.searchText)
        this.todoList();
    };
    goBack() {
        window.history.back();
    }
    back() {
        window.location.href = '/todos/';
    }
    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        //Name
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "This field is required.";
        }
        if (fields["relation"] && !this.isValidNumber(fields["relation"])) {
            formIsValid = false;
            errors["relation"] = "Please Provide Numbers Only.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    fileSelecthandler = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }
    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }
    GetTodosTitle(searchText = '') {
        fetch(this.state.apiUrl + '/TodoRest/GetTodosTitle/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.$todos,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }

    todoList(page = 1) {
        fetch(this.state.apiUrl + '/todoRest/getTodos/page/' + page + '/search/' + this.state.searchText + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    loading: 0,
                    todos: findresponse.todos,
                    owners: findresponse.owner,
                    item_count: findresponse.item_count,
                    config: findresponse.config,
                })
            })
    }
    insertTodo() {
        //e.preventDefault();
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("add_todo").innerHTML = "Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }

        // document.getElementById("add_todo").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/TodoRest/InsertTodo/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/userName/' + this.state.userName, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_todo").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/todos/';
                    });
                }
                else if (findresponse.code == 500) {
                    this.setState({ etaDate: findresponse.msg }, function () {
                    });
                }
                else if (findresponse.code == 700) {
                    this.setState({ etaDate: findresponse.msg }, function () {
                    });
                }
            })
    }

    onChange(event) {
        let fields = this.state.fields;
        fields[event.target.name] = event.target.value;
    }
    startdateChange(date) {
        this.setState({
            start_date: date,
            startDate: moment(date).format("YYYY-MM-DD")
        }, function () {
        });
    }
    etadateChange(date) {
        this.setState({
            ETA: date,
            eta: moment(date).format("YYYY-MM-DD")
        }, function () {
        });
    }
    addTodoDetails() {
        fetch(this.state.apiUrl + '/TodoRest/Adddetails/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/todos';
                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }
                this.setState({
                    owners: findresponse.owner,
                    priority: findresponse.priority,
                    status: findresponse.status,

                })
            })
    }

    onToggle(obj) {
        var obj = document.getElementById('showmore')
        if (obj.classList.contains('collapsed')) {
            obj.innerHTML = 'Show More';
        } else {
            obj.innerHTML = 'Show Less';
        }
    }
    componentDidMount() {
        document.title = "Intranet | Add To Do";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.addTodoDetails();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();

            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });


            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });

            } else {
                alert("Your browser doesn't support to File API")
            }

        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Add Todo's" brecum_page="Add To Do" />
                <div class="right_col">
                    <div class="ticket_list">
                        <div className="intranet_body">
                            <div class="title mob"><HeaderMob page_name="Add To Do" /></div>
                            <div className="form-group">
                                <label>Title <span class="star">*</span> </label>
                                <input type="text" name="title" id="title" className="form-control" onChange={this.onChange} />
                                <span style={{ color: "red" }}>{this.state.errors["title"]}</span>
                            </div>
                            <div class="form-section add row">
                                <div className="form-group col-md-4 col-xs-6">
                                    <label>Owner <span class="star">*</span></label>
                                    <select id="owner" class="form-control" name="owner" onChange={this.onChange} >
                                        <option value={this.state.userId} selected="selected">{this.state.userName} </option>
                                        {
                                            this.state.owners.map((owner, key) =>
                                                <option value={owner.id}>{owner.name}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div className="form-group col-md-4 col-xs-6">
                                    <label>Priority </label>
                                    <select class="form-control" name="priority_name" id="" onChange={this.onChange} >
                                        <option value='30'>Medium</option> 
                                        <option value='10'>Critical</option>
                                        <option value='20'>High</option>
                                        <option value='40'>Low</option>
                                        {/* {
                                            this.state.priority.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        } */}
                                    </select>
                                    
                                </div>
                                <div className="form-group col-sm-4 col-xs-12">
                                    <label>Visibility  <span class="star">*</span></label>
                                    <div class="manage_ticket">
                                        <label class="custom_radio_ui">
                                            <input type="radio" name="visibility" id="visibility1" value="Owner & My manager" onChange={this.onChange} />
                                            <span></span>Owner & My manager
                    </label>
                                        <label class="custom_radio_ui">
                                            <input type="radio" name="visibility" id="visibility1" value="public" onChange={this.onChange} checked = "checked" />
                                            <span></span>Public
                    </label>
                                    </div>
                                </div>

                                <div class="collapse er_advance" id="collapseExample">
                                    <div class="card card-body">
                                        <div class="form-section add">
                                            <div className="form-group col-md-12">
                                                <label>Description</label>
                                                <textarea class="checkSpace form-control" name="description" id="description" rows='8' cols='160' onChange={this.onChange} ></textarea>
                                            </div>
                                            <div className="form-group col-md-3 col-xs-12">
                                                <label>Status</label>
                                                <select class="form-control" name="status" id="status" onChange={this.onChange} >
                                                    <option value='' selected >Any</option>
                                                    {
                                                        this.state.status.map((dynamicData, index) =>
                                                            <option value={dynamicData.key}>{dynamicData.value}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 col-xs-12">
                                                <label>Related To</label>
                                                <input type="text" name="relation" className="form-control" onChange={this.onChange} />
                                                <span style={{ color: "red" }}>{this.state.errors["relation"]}</span>
                                            </div>
                                            
                                            <div class="form-group col-md-3 col-xs-6 icon-calender">
                                                <label>Start Date</label>
                                                <div class="filter">
                                                    <DatePicker
                                                        selected={this.state.start_date}
                                                        selectsStart
                                                        onChange={this.startdateChange}
                                                        readOnly={true}
                                                        minDate={moment()}
                                                        maxDate={this.state.ETA}
                                                        placeholderText="Start Date"
                                                        dateFormat="DD/MM/YYYY"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"

                                                    />
                                                    <i class="fal fa-calendar-alt"></i>
                                                </div>
                                                <span style={{ color: "red" }}>{this.state.etaDate}</span>
                                            </div>
                                            <div class="form-group col-md-3 col-xs-6 icon-calender">
                                                <label>ETA</label>
                                                <div class="filter right">
                                                    <DatePicker
                                                        selected={this.state.ETA}
                                                        selectsEnd
                                                        onChange={this.etadateChange}
                                                        readOnly={true}
                                                        minDate={this.state.start_date == '' ? moment() : this.state.start_date}
                                                        placeholderText="ETA"
                                                        dateFormat="DD/MM/YYYY"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    />
                                                    <i class="fal fa-calendar-alt"></i>
                                                </div>
                                                <span style={{ color: "red" }}>{this.state.etaDate}</span>
                                            </div>
                                        </div>
                                        <div class="upload todo">
                                            <label>Add Attachment :</label>
                                            <div class="upload_btn">
                                                <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                <label for="fileInput">
                                                    <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                                    <span>Choose file</span>
                                                    <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='form-group'>
                                <button className="btn btn-sky" id="showmore" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" onClick={this.onToggle.bind()}>Show More</button>
                                <button type="submit" name="add_todo" id="add_todo" className="btn btn-sky mob-btn" onClick={() => this.insertTodo()}>Submit</button>
                                <button className="btn btn-blue mob-btn hidden-xs" onClick={() => this.back()}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddTodo;


// WEBPACK FOOTER //
// ./src/components/todo/addTodo.js